import styled from '@emotion/styled'

const VerticalBar = styled.span`
  color: ${({ theme }) => theme.color.gray200};
  padding: 0 0.5rem;
`

export default VerticalBar
